module.exports = __webpack_public_path__ + "static/GlitchlessSonyax5c-22dd096b6eef84ba7d20bc9b2b765601.png";